import React from 'react'
import Sales from '../../Components/Admin/Sales/Sales'

const AdminSalesPage = () => {
  return (
    <div className="p-5">
      <Sales />
    </div>
  )
}

export default AdminSalesPage
